import { createSlice } from '@reduxjs/toolkit';

export const referralSlice = createSlice({
  name: 'referral',
  initialState: {
    allReferralDocs: [],
  },
  reducers: {
    handAllReferralDocs: (state, action) => {
      state.allReferralDocs = action.payload;
    },
  },
});

export const { handAllReferralDocs } = referralSlice.actions;
export default referralSlice.reducer;
